import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldBase } from "../models/field-base";

@Component({
  selector: "sd-form-field",
  templateUrl: "./sd-form-field.component.html",
  styleUrls: ["./sd-form-field.component.css"],
})
export class SdFormFieldComponent implements OnInit {
  @Input() applicationFormField: FieldBase<any>;
  @Input() form: UntypedFormGroup;
  @Output() onBlurEvent: EventEmitter<string> = new EventEmitter();
  @Output() onDateSelectEvent: EventEmitter<any> = new EventEmitter();

  get isValid() {
    return this.form.controls[this.applicationFormField.key].valid;
  }
  constructor() { }

  ngOnInit() { }

  handleBlur(key) {
    this.onBlurEvent.emit(key);
  }

  dateSelectEvent(key) {
    this.onDateSelectEvent.emit(key);
  }

}
